import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import i18n  from "l10n";

export default GenericView.extend({
    el: "#mapLocation",
    tagName: "div",
    currentMarkerOnMap: null, //current Marker on the map
    markers: null, //saved markers
    map: null,
    geocoder: null,
    pos: { //default map center, Greece
        lat: 38.4201466,
        lng: 23.4343889
    },
    mapOptions: {
        center: new google.maps.LatLng(39.0186437, 27.6722559),
        zoom: 6,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false
    },
    initialize: function(options) {
        var self = this;

        this.geocoder = new google.maps.Geocoder();
        this.renderMap();
    },
    renderMap: function() {
        var self = this;
        this.map = new google.maps.Map(document.getElementById("map"), this.mapOptions);
        this.rewireMapEvents(); //needed since google "clears" map when the container DIV is getting hidden

        this.showMap();
        this.rewireButtonEvents();
    },
    events: {

    },
    rewireButtonEvents: function() {
        var self = this;

        //rewire events, since we update the template
        $(".mapLocationSearchbox").unbind("keyup").on("keyup", function(evt) { self.searchForAddress(evt); });
    },
    rewireMapEvents: function() {
        var self = this;
        google.maps.event.addListener(this.map, 'click', function(event) {
            self.pinChange(event.latLng);
        });
    },
    pinChange: function(latLng) {
        var self = this;

        if(this.currentMarkerOnMap == null) {
            this.currentMarkerOnMap = new google.maps.Marker({
                position: latLng,
                map: self.map
            });
        } else {
            this.currentMarkerOnMap.setPosition(latLng);
            this.currentMarkerOnMap.setMap(this.map);
        }

        var templatLng = this.currentMarkerOnMap.position.lat() + "," + this.currentMarkerOnMap.position.lng();

        $.ajaxDefaultQ({
            url: "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + templatLng + "&key=AIzaSyCnolVy00NdU174ronzBT7ysFuGT9WaCr4",
            crossDomain: true,
            dataType: 'json',
            contentType: "application/x-www-form-urlencoded; charset=UTF-8"
        }).done(function(response, status, xhr){
            self.totalCalls = self.totalCalls - 1;
            if(self.totalCalls == 0 &&self.callback && self.callback.success)
                self.callback.success(response);

            var address = response.results[0].formatted_address;
            $("#AddressSearchbox").val(address);
        })
        .fail(function(response) {
            self.totalCalls = self.totalCalls - 1;
            if(self.totalCalls == 0 &&self.callback && self.callback.success)
                self.callback.success(response);

        });
        this.map.setCenter(latLng);
        this.map.setZoom(15);
    },
    placeMarkerOnMap: function(latLng) {
        var self = this;

        if(this.currentMarkerOnMap == null) {
            this.currentMarkerOnMap = new google.maps.Marker({
                position: latLng,
                map: self.map
            });
        } else {
            this.currentMarkerOnMap.setPosition(latLng);
            this.currentMarkerOnMap.setMap(this.map);
        }

        this.map.setZoom(15);
        this.map.setCenter(latLng);
    },
    searchForAddress: _.debounce(function(e) {
        var self = this;
        var input = $(e.currentTarget);

        var searchText = input.val();
        this.geocoder.geocode( { 'address': searchText }, function(results, status) {

            if (status == google.maps.GeocoderStatus.OK) {
                var formattedAddress = results[0].formatted_address;

                self.map.panTo(results[0].geometry.location);

                self.placeMarkerOnMap(results[0].geometry.location);

            } else if (status == google.maps.GeocoderStatus.ZERO_RESULTS) {
                $("#mapLocationSearchbox").notify(i18n.t("venue.address_invalid")+"!", { position:"top center", className: "warn", autoHide: true, autoHideDelay: 2500 });
            }

        });
    }, 800),
    saveMarkerClicked: function() {

        $("#address").find("input").val($("#mapLocationSearchbox").find("input").val());
        if (this.currentMarkerOnMap != null)
        {
            $("#latitude").find("input").val(this.currentMarkerOnMap.position.lat());
            $("#longitude").find("input").val(this.currentMarkerOnMap.position.lng());
        }


        if($("#address").find("input").val() != "") {
            $("#address").removeClass("has-error");
        } else {
            $("#addressError").text(i18n.t("account.empty_field"));
            $("#address").addClass("has-error");
        }
    },
    showMap: function() {
        var self = this;
        $("body").addClass("noScroll");

        $("#mapContainer").show();
        google.maps.event.trigger(this.map, 'resize'); //trigger resize event, so the map will be redrawn (since google clears the container, when it is set 'hidden')

        if($("#address").find("input").val() != "")
            $("#mapLocationSearchbox").find("input").val($("#address").find("input").val());
        else
            $("#mapLocationSearchbox").find("input").val("");

        if( ($("#latitude").find("input").val() != "") && ($("#longitude").find("input").val() != "") ) {
            var latLng = {
                lat: Number($("#latitude").find("input").val()),
                lng: Number($("#longitude").find("input").val())
            };
            this.placeMarkerOnMap(latLng);
            this.map.setCenter(latLng);
        } else {
            // if there is no marker in the map, when the user
            // reopens the div, shows the default position
            this.map.setCenter(this.pos);
        }
    },
});

